module.exports = __webpack_public_path__ + "img/video-poster.5ff3fbab.png";